import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { FirebaseListObservable } from 'angularfire2/database';

import { DBService } from '../../db.service';
import { slide } from '../../animations';

@Component({
  selector: 'surveys-list',
  templateUrl: './surveys-list.component.html',
  styleUrls: ['./surveys-list.component.scss'],
  animations: [slide]
})
export class SurveysListComponent implements OnInit {
  surveys:  FirebaseListObservable<any[]>;
  selectedSurvey: any;

  showModalBg = false;
  showFormModal = false;
  showDeleteModal = false;

  constructor(
    private router: Router,
    private dbService: DBService
  ) {

    this.surveys = this.dbService.getSurveys();

  }


  ngOnInit() {
  }


  showSurvey(key: string) {
    this.router.navigate([`/surveys/${key}`]);
  }


  onAddClicked() {
    this.selectedSurvey = null;
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onEditClicked(survey, event) {
    event.stopPropagation();
    this.selectedSurvey = survey;
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onDeleteClicked(survey, event) {
    event.stopPropagation();
    this.showModalBg = true;
    this.showDeleteModal = true;
    this.selectedSurvey = survey;
  }

  onConfirmDelete() {
    this.onHideDeleteModal();
    this.dbService.deleteSurvey(this.selectedSurvey.$key);
  }

  onHideFormModal() {
    this.showFormModal = false;
    this.showModalBg = false;
  }

  onHideDeleteModal() {
    this.showDeleteModal = false;
    this.showModalBg = false;
  }

  accessControl(survey, acl) {
    if (survey.userLevels[acl] == true) {
      return "<span class='check'>✔</span>";
    } else {
      return "<span class='cross'>✖</span>";
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/surveys/surveys-list/surveys-list.component.ts